export default __webpack_public_path__ + "static/media/map.c3c497da.png";